/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddRoleToCompanyRequest
 */
export interface AddRoleToCompanyRequest {
    /**
     * `権限名`
     * @type {string}
     * @memberof AddRoleToCompanyRequest
     */
    roleName: string;
}

/**
 * Check if a given object implements the AddRoleToCompanyRequest interface.
 */
export function instanceOfAddRoleToCompanyRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roleName" in value;

    return isInstance;
}

export function AddRoleToCompanyRequestFromJSON(json: any): AddRoleToCompanyRequest {
    return AddRoleToCompanyRequestFromJSONTyped(json, false);
}

export function AddRoleToCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddRoleToCompanyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roleName': json['role_name'],
    };
}

export function AddRoleToCompanyRequestToJSON(value?: AddRoleToCompanyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role_name': value.roleName,
    };
}

